// extracted by mini-css-extract-plugin
export default {"chip-container":"filter-chips__chip-container___3Ma0K","clear-all":"filter-chips__clear-all___l_D6n"};